import React from 'react';
import Router, { useRouter } from 'next/router';
import storage from 'local-storage-fallback';
import { useCurrentUser } from '../../@mrkt/useCurrentUser';
import { Wait } from '../Layout';

type LoggedInRedirectProps = {
  children: React.ReactNode;
  activeSession: boolean;
};

export const LoggedInRedirect: React.FC<LoggedInRedirectProps> = ({
  children,
  activeSession,
}) => {
  const router = useRouter();
  const doCheck = activeSession && Object.keys(router.query).length === 0;
  const [loading, setLoading] = React.useState(doCheck);
  const user = useCurrentUser();

  React.useEffect(() => {
    if (!doCheck || user === undefined) {
      return;
    }

    const redirectedKey = `${user?.username}:analytics:loggedInRedirect`;
    if (user?.hasAccess) {
      storage.setItem(redirectedKey, 'true');
      Router.push('/c');
    } else {
      storage.removeItem(redirectedKey);
      setLoading(false);
    }
  }, [user]);

  return (
    <div data-testid="logged-in-redirect">
      {(!loading && children) || <Wait cover />}
    </div>
  );
};
